// Apolo IDE — TableBlockBody (sprint plan-tab-v1, E3).
//
// Tabela inline editável, sem libs. Suporta add/remove row, add/remove
// column, edit header e células. Visual minimal pra caber em card.

import { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';

export default function TableBlockBody({ payload, onChange, accent }) {
  const [headers, setHeaders] = useState(payload.headers || ['Coluna A', 'Coluna B']);
  const [rows, setRows] = useState(payload.rows || [['', '']]);

  function commit(nextHeaders = headers, nextRows = rows) {
    onChange({ ...payload, headers: nextHeaders, rows: nextRows });
  }

  function setHeader(idx, value) {
    const next = headers.map((h, i) => (i === idx ? value : h));
    setHeaders(next); commit(next, rows);
  }
  function setCell(r, c, value) {
    const next = rows.map((row, i) => (i === r ? row.map((cell, j) => (j === c ? value : cell)) : row));
    setRows(next); commit(headers, next);
  }
  function addRow() {
    const next = [...rows, headers.map(() => '')];
    setRows(next); commit(headers, next);
  }
  function removeRow(r) {
    if (rows.length <= 1) return;
    const next = rows.filter((_, i) => i !== r);
    setRows(next); commit(headers, next);
  }
  function addCol() {
    const nh = [...headers, `Coluna ${String.fromCharCode(65 + headers.length)}`];
    const nr = rows.map((row) => [...row, '']);
    setHeaders(nh); setRows(nr); commit(nh, nr);
  }
  function removeCol(c) {
    if (headers.length <= 1) return;
    const nh = headers.filter((_, i) => i !== c);
    const nr = rows.map((row) => row.filter((_, i) => i !== c));
    setHeaders(nh); setRows(nr); commit(nh, nr);
  }

  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex items-center gap-1 border-b border-apolo-borderSubtle/60 px-3 py-1.5 text-[10px] uppercase tracking-wide" style={{ color: accent }}>
        <span>Tabela</span>
        <span className="ml-auto inline-flex gap-1">
          <button type="button" onClick={addCol} className="inline-flex items-center gap-0.5 rounded px-1.5 py-0.5 text-[10px] hover:bg-apolo-surface3" aria-label="Adicionar coluna">
            <Plus size={9} />col
          </button>
          <button type="button" onClick={addRow} className="inline-flex items-center gap-0.5 rounded px-1.5 py-0.5 text-[10px] hover:bg-apolo-surface3" aria-label="Adicionar linha">
            <Plus size={9} />lin
          </button>
        </span>
      </div>
      <div className="flex-1 overflow-auto p-2">
        <table className="w-full border-collapse text-xs">
          <thead>
            <tr>
              {headers.map((h, c) => (
                <th key={c} scope="col" className="border border-apolo-borderSubtle/60 bg-apolo-surface2/60 p-0">
                  <div className="group flex items-center">
                    <input
                      type="text"
                      value={h}
                      onChange={(e) => setHeader(c, e.target.value)}
                      className="w-full border-0 bg-transparent px-2 py-1.5 text-left text-[11px] font-semibold text-apolo-textPrimary focus:outline-none focus:bg-apolo-plan-accentMuted"
                    />
                    <button
                      type="button"
                      onClick={() => removeCol(c)}
                      aria-label={`Remover coluna ${h}`}
                      className="invisible inline-flex h-5 w-5 items-center justify-center text-apolo-textTertiary hover:text-apolo-error group-hover:visible"
                    >
                      <Trash2 size={9} />
                    </button>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, r) => (
              <tr key={r} className="group">
                {row.map((cell, c) => (
                  <td key={c} className="border border-apolo-borderSubtle/40 p-0">
                    <input
                      type="text"
                      value={cell}
                      onChange={(e) => setCell(r, c, e.target.value)}
                      className="w-full border-0 bg-transparent px-2 py-1 text-[11px] text-apolo-textPrimary focus:outline-none focus:bg-apolo-plan-accentMuted/60"
                    />
                  </td>
                ))}
                <td className="w-0 border-0 p-0">
                  <button
                    type="button"
                    onClick={() => removeRow(r)}
                    aria-label={`Remover linha ${r + 1}`}
                    className="invisible inline-flex h-6 w-6 items-center justify-center text-apolo-textTertiary hover:text-apolo-error group-hover:visible"
                  >
                    <Trash2 size={10} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
